module.exports = __webpack_public_path__ + "static/media/img_event5.ac8d592c.png";